import type { ConsentPolicy } from '@wix/cookie-consent-policy-client';
import type { GeoData } from '@wix/wix-common-aspects';
import type { AppConfig } from '../../config';

export interface ConfigStoreState {
  currentLanguage: string;
  supportedLanguages: string[];
  baseURL: string;
  domain: string;
  // Request-derived device flag (Smartphone/Tablet => true). Set server-side from
  // web.UserAgentInfo and serialized to the client so SSR and hydration agree on the
  // device branch. Do NOT derive this from useMediaQuery — that is unsafe during SSR.
  isMobile: boolean;
  geoData: GeoData | undefined;
  renamedCategories: AppConfig['renamedCategory'];
  templatePageSessionId: string;
  imagesMediaPlatformDomain: string;
  consentPolicy?: ConsentPolicy;
  introReferrer: string;
  userId: string | undefined;
}

export class ConfigStore {
  constructor(public readonly config: ConfigStoreState) {}

  serialize(): ConfigStoreState {
    return this.config;
  }
}
